import { sendMessageUp } from '@/helpers/iframeMessages';
import isBrowser from '@/helpers/isBrowser';

const createCookie = (name: string, value: string, days?: number): string => {
  if (!isBrowser()) {
    return '';
  }

  // This means that the cookie is created here is different from the one  in widget and here. Should be the same, but that's later.
  sendMessageUp({
    message: 'set-client-cookie',
    value: { token: value },
  });

  const parts = [];
  parts.push(`${name}=${value}`);

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    parts.push(`expires=${date.toUTCString()}`);
  }

  const isSecureContext = window.location.protocol === 'https:';
  parts.push('path=/');
  // SameSite=None requires Secure, and Secure requires HTTPS.
  // Safari enforces this strictly (no localhost exception), so fall back to Lax over HTTP.
  parts.push(isSecureContext ? 'SameSite=None' : 'SameSite=Lax');

  // make cookie available on all subdomains.
  // count on the name being different on different tiers so that staging.glade.ai and glade.ai don't get the same cookie.
  const { host } = window.location;
  const hostname = host.replace(/:\d+$/, '');
  const hostParts = hostname.split('.').reverse();
  const isIpAddress = /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);

  if (!isIpAddress && hostParts.length >= 2) {
    parts.push('Secure', `domain=.${hostParts[1]}.${hostParts[0]}`);
  } else if (isSecureContext) {
    parts.push('Secure');
  }

  const cookie = parts.join('; ');
  document.cookie = cookie;
  return cookie;
};

export default createCookie;
